import { Suspense } from "react";
import { projectAssetsHydratedAtom_SUSPENDS } from "@zapier/canvas-state";
import { useAtomValue } from "jotai";

/* This is to fetch project asset data in the background in case the user hasn't opened the project sidebar yet */
function HiddenProjectAssetsFetcherInner() {
  useAtomValue(projectAssetsHydratedAtom_SUSPENDS);
  return null;
}

export default function HiddenProjectAssetsFetcher() {
  return (
    <Suspense fallback={null}>
      <HiddenProjectAssetsFetcherInner />
    </Suspense>
  );
}
